import React from "react";
import { ICONS } from "assets/icons";

const GettingStartedCard = ({ steps }) => {
  if (!steps.length) return null;

  const allCompleted = steps.every((step) => step.completed);
  // if (allCompleted) return null;

  return (
    <div className="bg-[var(--surface)] rounded-2xl p-6 shadow-[0px_20px_50px_-32px_rgba(15,23,42,0.35)] border border-[var(--surface-border)]">
      <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
        <div>
          <p className="text-[18px] font-semibold text-[var(--textBlack)]">
            Getting started
          </p>
          <p className="text-sm text-[var(--font-600)]">
            Do these in order to unlock full campaign performance.
          </p>
        </div>
        {/* {!allCompleted && (
          <span className="text-xs bg-[var(--accent-soft)] text-[var(--accent-2)] px-3 py-1 rounded-full font-semibold">
            Next recommended • {steps.find((s) => !s.completed)?.title}
          </span>
        )} */}
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        {steps.map((step) => {
          const isNext = !step.completed && steps.find((s) => !s.completed)?.id === step.id;
          return (
            <button
              key={step.id}
              type="button"
              onClick={step.action}
              className={`text-left rounded-2xl border p-4 transition-all hover:-translate-y-1 ${
                step.completed
                  ? "border-[#D7F0E3] bg-[#F2FBF7]"
                  : isNext
                  ? "border-[var(--accent-2)] bg-[#f7f3ff]"
                  : "border-[#EEF0F4] bg-white hover:border-[#D9C7FF]"
              }`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div
                    className={`w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold ${
                      step.completed
                        ? "bg-[#0ACD95] text-white"
                        : "bg-[#F4F2FF] text-[#6940F2]"
                    }`}
                  >
                    {step.completed ? "✓" : step.id}
                  </div>
                  <span className="font14px-600 text-[var(--textBlack)]">
                    {step.title}
                  </span>
                </div>
                {step.completed && (
                  <img
                    src={ICONS?.homeSuccess}
                    alt="completed"
                    className="w-4 h-4"
                  />
                )}
                {isNext && !step.completed && (
                  <span className="text-[11px] font-semibold text-[var(--accent-2)]">
                    Next up
                  </span>
                )}
              </div>
              <p className="mt-3 text-sm text-[var(--font-600)]">
                {step.description}
              </p>
              <span
                className={`mt-3 inline-flex items-center gap-1 text-sm ${
                  step.completed ? "text-[#0ACD95]" : "text-[#6940F2]"
                }`}
              >
                {step.completed ? "Completed" : "Start now"}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default GettingStartedCard;
